export class UserCreditStudyQuery {
  public readonly _tag = 'UserCreditStudyQuery';
}
